import { GoogleLogin } from '@react-oauth/google';
import { GradientAnimationBackground } from '../components/background';

import PropTypes from 'prop-types';
import React from 'react';

const LoginLayout = React.memo(function LoginLayout({
    handleLoginSuccess,
    handleLoginError,
    isLoading,
}) {
    return (
        <GradientAnimationBackground>
            <div className="relative flex min-h-screen flex-col items-center">
                <div className="relative flex w-full max-w-[25rem] flex-1 flex-col justify-center gap-y-6 ">
                    <main className="relative flex-1 content-center px-2 lg:px-0 block">
                        <div className="relative w-full lg:min-h-[calc(545/16*1rem)]">
                            <div className="box-border flex flex-col items-stretch gap-8 bg-white transition-colors duration-200 text-center z-10 rounded-lg relative p-8 pt-8 pb-8 pr-10 pl-10 justify-center shadow-2xl">
                                <div className="box-border flex flex-col items-stretch justify-start gap-6">
                                    <div className="box-border flex flex-row items-stretch justify-center h-10">
                                        <img
                                            src="https://www.quantanite.com/wp-content/uploads/2025/02/mobius_logo.png"
                                            alt="Logo"
                                            className="h-full w-full object-contain"
                                        />
                                    </div>
                                    <div className="box-border flex flex-col items-stretch justify-start gap-1">
                                        <h1 className="box-border text-neutral-950 m-0 font-inherit tracking-normal font-bold text-base">
                                            Sign in to Hire To Retire
                                        </h1>
                                        <div className="box-border m-0 text-sm font-inherit tracking-normal font-normal text-slate-700 break-words">
                                            Welcome back! Please sign in to continue
                                        </div>
                                    </div>
                                </div>

                                <div className="box-border flex flex-col items-stretch justify-start gap-6">
                                    {isLoading ? (
                                        <button
                                            type="button"
                                            className="inline-flex items-center px-4 py-2 font-semibold leading-6 text-sm shadow rounded-md text-white bg-blue-500 hover:bg-blue-400 transition ease-in-out duration-150 cursor-not-allowed"
                                            disabled=""
                                        >
                                            <svg
                                                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <circle
                                                    className="opacity-25"
                                                    cx="12"
                                                    cy="12"
                                                    r="10"
                                                    stroke="currentColor"
                                                    strokeWidth="4"
                                                ></circle>
                                                <path
                                                    className="opacity-75"
                                                    fill="currentColor"
                                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                ></path>
                                            </svg>
                                            Processing...
                                        </button>
                                    ) : (
                                        <form method="POST">
                                            <GoogleLogin
                                                size="large"
                                                width="310px"
                                                onSuccess={handleLoginSuccess}
                                                onError={handleLoginError}
                                                useOneTap={false}
                                                cookiePolicy="single_host_origin"
                                                ux_mode="popup"
                                                context="signin"
                                                prompt="select_account"
                                                type="standard"
                                                shape="rectangular"
                                                theme="outline"
                                                text="signin_with"
                                                cancel_on_tap_outside={false}
                                            />
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </GradientAnimationBackground>
    );
});

LoginLayout.propTypes = {
    handleLoginSuccess: PropTypes.func.isRequired,
    handleLoginError: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
};

export default LoginLayout;
